import * as React from 'react';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import { css } from "@emotion/react"
import Link from 'next/link'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
import styled from "@emotion/styled";
import SwipeableViews from 'react-swipeable-views';

// actions
import { toggleDrawer } from '~/slices/commons/drawer'
import { setTab } from '~/slices/commons/searchDrawerTab'

// components
import { CatalogCodeTab } from "./searchTab/catalogCode";
import { DetailTab } from "./searchTab/detail";
import { PresetTab } from "./searchTab/preset";
import {
  Box,
  Drawer,
  Tab,
  Tabs,
  Button,
  List,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText } from '@material-ui/core';

// resources
import colorPalette from "~/theme/colorPalette";
import {useTheme} from "@material-ui/core/styles";
import {makeStyles} from "@material-ui/styles";
import {useWindowDimensions} from "../../../../services/hooks/common";

export default function SearchDrawer(props) {
  const { width, height } = useWindowDimensions();

  const { openFlg, key } = useSelector((state) => state.drawer)
  const tabId = useSelector((state) => state.searchDrawerTab.id)
  const dispatch = useDispatch()

  const handleChangeIndex = (index) => {
    dispatch(setTab({id: index}))
  };

  const swipeableIndex = {
    'detail': 0,
    'preset': 1,
    'catalogCode': 2,
  }
  
  const theme = useTheme()
  const useStyles = makeStyles({
    drawerPaper: {
      [theme.breakpoints.up('md')]: {
        left: 0,
        right: 0
      },
      [theme.breakpoints.up('lg')]: {
        width: `${width <= 960 ? 'auto' : '960px'}`,
        left: 0,
        right: 0,
        margin: '0 auto',
      },
    },
  })
  
  const classes = useStyles()
  
  return (
      <Drawer
          anchor={'top'}
          open={openFlg && key === 'search'}
          onClose={() => dispatch(toggleDrawer({openFlg: false, key: 'search'}))}
          css={position}
          classes={{paper: classes.drawerPaper}}
      >
        <Box
            sx={{ width: 'auto' }}
            role="presentation"
            //onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'search'}))}
            //onKeyDown={() => dispatch(toggleDrawer({openFlg: false, key: 'search'}))}
            css={props.isSpacer ? marginTopAddSpacer : marginTop}
        >
          <div css={searchArea}>
            <Tabs
                value={tabId}
                centered
                variant='fullWidth'
            >
              <Tab value={swipeableIndex['detail']} onClick={() => dispatch(setTab({id: swipeableIndex['detail']}))} label="絞り込み" css={tabStyle} />
              <Tab value={swipeableIndex['preset']} onClick={() => dispatch(setTab({id: swipeableIndex['preset']}))} label="条件" css={tabStyle} />
              <Tab value={swipeableIndex['catalogCode']} onClick={() => dispatch(setTab({id: swipeableIndex['catalogCode']}))} label="カタログ番号" css={tabStyle} />
            </Tabs>
            <SwipeableViews
                index={tabId}
                onChangeIndex={handleChangeIndex}
            >
              <DetailTab value={swipeableIndex['detail']} index={'0'}/>
              <PresetTab value={swipeableIndex['preset']} index={'1'}/>
              <CatalogCodeTab value={swipeableIndex['catalogCode']} index={'2'}/>
            </SwipeableViews>
          </div>
        </Box>
      </Drawer>
  );
}

const position = css`
    z-index: 99;
  `

const marginTop = css`
  padding-top: 70px;
`

const marginTopAddSpacer = css`
  padding-top: 112px;
`

const tabStyle = css`
  border-color: #cccccc;
  border-bottom-width: 2px;
  border-bottom-style: solid;
`

const searchArea = css`
  max-width: 760px;
  margin: 0 auto;
`